<template lang="pug">
.d-drag-and-drop-base.transparent(
  v-bind="$attrs"
  v-on="$listeners"
  @dragenter.prevent.stop="dragEnter"
  @dragleave.prevent.stop="dragLeave"
  @dragover.prevent.stop
  @drop.prevent.stop="drop"
)
  slot(v-bind="{ dragging }")
</template>

<script>

export default {
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    sendDragging(state) {
      this.dragging = state;
      this.$emit('dragging', state);
    },
    dragEnter() {
      this.sendDragging(true);
    },
    dragLeave() {
      this.sendDragging(false);
    },
    drop(e) {
      this.dragLeave();
      const { files } = e.dataTransfer;
      if (files?.length) {
        this.$emit('drop-files', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.d-drag-and-drop-base {
  & * {
    pointer-events: none;
  }
}
</style>
